import { fetchAsync, postAsync } from '../common/fetch';
import {
  HotelPaymentRequest,
  ICreatePaymentUrlResponse,
  IPaymentSetting,
  IPaymentStatusResponse,
  IVietQRUrlRequest,
  IVietQRUrlResponse,
} from '../types/paymentTypes';

export const createPaymentUrl = (req: HotelPaymentRequest) =>
  postAsync<HotelPaymentRequest, ICreatePaymentUrlResponse>('/vnpay/create_payment_url', req);

export const getPaymentStatus = (search: string) =>
  fetchAsync<IPaymentStatusResponse>(`/vnpay/verify_callback${search}`);

export const createVietQRUrl = (req: IVietQRUrlRequest) => {
  return postAsync<IVietQRUrlRequest, IVietQRUrlResponse>('/payment/vietqr/create_payment_url', req);
};

export const getPaymentSettings = () => fetchAsync<IPaymentSetting[]>(`/payment/settings`);
